export const cutString = (str: string, { start, end }: { start?: number; end?: number }) => {
	if (end) {
		str = str.slice(0, str.length - end);
	}

	if (start) {
		str = str.slice(start);
	}

	return str;
};
